export var RelationshipLagCalendar;
(function (RelationshipLagCalendar) {
    RelationshipLagCalendar["PREDECESSOR"] = "PREDECESSOR";
    RelationshipLagCalendar["SUCCESSOR"] = "SUCCESSOR";
    RelationshipLagCalendar["PROJECT_DEFAULT"] = "PROJECT_DEFAULT";
    RelationshipLagCalendar["TWENTY_FOUR_HOUR"] = "TWENTY_FOUR_HOUR";
})(RelationshipLagCalendar || (RelationshipLagCalendar = {}));
export var WorkingType;
(function (WorkingType) {
    WorkingType["working"] = "working";
    WorkingType["nonWorking"] = "non_working";
})(WorkingType || (WorkingType = {}));
